import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SplitUrlPipe } from './split-url.pipe';

@NgModule({
  declarations: [SplitUrlPipe],
  imports: [CommonModule],
  exports: [SplitUrlPipe]
})
export class SplitUrlModule {}
